import { Routes, Route, Navigate } from "react-router-dom";

import { ROUTES } from "./routes";

import AuthorizationLayout from "@shared/layouts/AuthorizationLayout/AuthorizationLayout";
import MainLayout from "@shared/layouts/MainLayout/MainLayout";
import { AuthorizedUserGuard } from "@shared/components/guards/authorized-user-guard";
import { UnauthorizedUserGuard } from "@shared/components/guards/unauthorized-user-guard";
import Players from "../pages/Players/Players";
import Notifications from "../pages/Notifications/Notifications";
import Configurations from "../pages/Configurations/Configurations";
import NotFound from "../pages/NotFound/NotFound";
import AccessDenied from "../pages/AccessDenied/AccessDenied";
import InternalServer from "../pages/InternalServer/InternalServer";
import { Login } from "../pages/Login";
import Users from "pages/Users/Users";
import Settings from "pages/Settings/Settings";
import Plans from "pages/Plans/Plans";
import Transactions from "pages/Transactions/Transactions";
import Popups from "pages/Popups/Popups";
import RestrictedUsernames from "pages/RestrictedUsernames/RestrictedUsernames";
import StoreBanners from "pages/StoreBanners/StoreBanners";
import Tiers from "pages/Tiers/Tiers";
import Baselines from "pages/Baselines/Baselines";
import RankedSeasonAnnouncement from "pages/RankedSeasonAnnouncement/RankedSeasonAnnouncement";
import Campaigns from "pages/Campaigns/Campaigns";
import CampaignPromoCodes from "pages/CampaignPromoCodes/CampaignPromoCodes";
import DailyAffiliateRevenue from "pages/DailyAffiliateRevenue/DailyAffiliateRevenue";

const AppRouter = () => (
  <Routes>
    <Route element={<UnauthorizedUserGuard />}>
      <Route element={<AuthorizationLayout />}>
        <Route path={ROUTES.LOGIN_PAGE} index element={<Login />} />
        {/*<Route path={routes.TWO_FA} element={<TwoFactorAuthentication />} />*/}
      </Route>
    </Route>

    <Route element={<AuthorizedUserGuard />}>
      <Route path={ROUTES.MAIN_PAGE} element={<MainLayout />}>
        <Route index element={<Navigate to={ROUTES.USERS} replace />} />
        <Route path={ROUTES.PLAYERS} element={<Players />} />
        <Route path={ROUTES.USERS} element={<Users />} />
        <Route path={ROUTES.NOTIFICATIONS} element={<Notifications />} />
        <Route path={ROUTES.SETTINGS} element={<Settings />} />
        <Route path={ROUTES.CONFIGURATIONS} element={<Configurations />} />
        <Route path={ROUTES.TRANSACTIONS} element={<Transactions />} />
        <Route path={ROUTES.POPUPS} element={<Popups />} />
        <Route
          path={ROUTES.RESTRICTED_USERNAMES}
          element={<RestrictedUsernames />}
        />
        <Route path={ROUTES.PLANS} element={<Plans />} />
        <Route path={ROUTES.STORE_BANNERS} element={<StoreBanners />} />
        <Route path={ROUTES.TIERS} element={<Tiers />} />
        <Route path={ROUTES.BASELINES} element={<Baselines />} />
        <Route
          path={ROUTES.RANKED_SEASON_ANNOUNCEMENT}
          element={<RankedSeasonAnnouncement />}
        />
        <Route path={ROUTES.CAMPAIGNS} element={<Campaigns />} />
        <Route
          path={ROUTES.CAMPAIGN_PROMO_CODES}
          element={<CampaignPromoCodes />}
        />
        <Route
          path={ROUTES.AFFILIATE_DAILY_REVENUE}
          element={<DailyAffiliateRevenue />}
        />
      </Route>
    </Route>

    <Route path={ROUTES.NOT_FOUND} element={<NotFound />} />
    <Route path={ROUTES.ACCESS_DENIED} element={<AccessDenied />} />
    <Route path={ROUTES.INTERNAL_SERVER} element={<InternalServer />} />
  </Routes>
);

export default AppRouter;
